module.exports = __webpack_public_path__ + "static/05-6731761812e37e505fb4578ec7a42a68.jpg";